import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../components/Button';
import { identifyComponent } from '../../util';
import { Box } from '../Box';
import { Divider } from '../Divider';
import { Flex } from '../Flex';

export interface MultiSelectMenuFooterProps {
  dirty: boolean;
  primaryAction?: {
    action: () => void;
    text: string;
    disabled?: boolean;
    /**
     * Close the menu when the primary action button is clicked.
     *
     * defaults to true
     */
    closeOnAction?: boolean;
  };

  onCancel: () => void;
  onApply: () => void;
}

export const MultiSelectMenuFooter: React.FC<MultiSelectMenuFooterProps> = ({
  dirty,
  primaryAction,
  onCancel,
  onApply,
}) => (
  <Box
    data-component="MultiSelectMenuFooter"
    width={1}
    {...identifyComponent('multi-select-menu-footer')}
  >
    <Divider />
    {primaryAction && !dirty ? (
      <Button
        variant="minimal"
        fullWidth
        onClick={() => {
          const { closeOnAction = true } = primaryAction;
          if (closeOnAction) onApply();
          primaryAction.action();
        }}
        disabled={primaryAction.disabled}
      >
        {primaryAction.text}
      </Button>
    ) : (
      <Box margin={[12, 16, 12, 16]}>
        <Flex justifyContent="flex-end" gap={16} flexWrap="wrap">
          <Button variant="minimal" onClick={onCancel} size="small">
            <FormattedMessage defaultMessage="Cancel" id="47FYwb" />
          </Button>
          <Button variant="fill-primary" onClick={onApply} disabled={!dirty} size="small">
            <FormattedMessage defaultMessage="Apply" id="EWw/tK" />
          </Button>
        </Flex>
      </Box>
    )}
  </Box>
);
